import React, { useContext, useMemo } from 'react';
import { CollectionItem } from '../types';
import { CollectionPageContext } from '../frontend/pageContext';
import CollectionTile from './HomepageContent/CollectionTile';

const Collection = () => {
  const { items } = useContext(CollectionPageContext);

  const itemTile = useMemo(
    () => (item: CollectionItem) => {
      return (
        <div key={item.id} className="collection-item-tile">
          <CollectionTile content={item} />
        </div>
      );
    },
    [],
  );

  return (
    <>
      {items.map((item) => {
        if (item.type === 'group') {
          return (
            <div
              key={item.id}
              style={{
                paddingLeft: item.nestedPosition
                  ? `${(item.nestedPosition.split('.').length - 1) * 32}px`
                  : undefined,
              }}
            >
              <h2 className="heading hide-mobile">{item.title}</h2>
              <div className="group-items">
                {item.children?.map((child) => itemTile(child))}
              </div>
            </div>
          );
        } else {
          return itemTile(item);
        }
      })}
    </>
  );
};
export default Collection;
